import DefaultLayout from "@/layouts/DefaultLayout";
import KPricingHelpForm from "kinnect-front/KPricingHelp/KPricingHelpForm";
import { Crudable, FetchesData, Pageable } from "kinnect-mixins";
import { KActionDialog } from "kinnect-general";
import { PricingHelp } from "kinnect-models";

export default {
	name: "PricingHelpPage",

	metaInfo() {
		const title = this.editing && this.fetched
			? `Pricing Help - ${this.pricingHelp.name}`
			: "Add Pricing Help";

		return { title: this.fetched ? title : null };
	},

	props: { idPricingHelp: Number },

	mixins: [
		Crudable,
		FetchesData,
		Pageable
	],

	data: () => ( {
		crud: "pricing_help",
		pricingHelp: null,
		deleteDialogOpen: false
	} ),

	computed: {
		editing() {
			return Boolean( this.idPricingHelp );
		},

		genDeleteDialog() {
			if ( this.editing && this.pricingHelp && this.canDelete ) {
				return <KActionDialog
					confirmButtonColor="error"
					confirmButtonText="Delete"
					loading={this.$wait.is( "delete pricing help" )}
					onConfirm={() => this.pricingHelp.delete()}
					redirect={[ "back", { name: "pricingHelpList" } ]}
					title="Delete Pricing Help"
					vModel={this.deleteDialogOpen}
				>
					Are you sure you want to delete the pricing help for <strong>{this.pricingHelp.name}</strong>?
				</KActionDialog>;
			}
		},

		toolbarActions() {
			if ( this.editing && this.canDelete ) {
				return {
					icon: "delete",
					onClick: () => this.deleteDialogOpen = true,
					text: "Delete Pricing Help",
					tooltip: "Delete this pricing help"
				};
			}
		}
	},

	methods: {
		async fetchPricingHelp() {
			if ( this.editing ) {
				this.pricingHelp = await PricingHelp.findPageModel( this.idPricingHelp );
			}
		},

		async fetch() {
			await this.fetchPricingHelp();
		}
	},

	render() {
		return <DefaultLayout maxWidth="700px">
			<KPricingHelpForm
				loading={this.$wait.is( "find pricing help" )}
				pricingHelp={this.pricingHelp}
				readonly={this.editing ? !this.canEdit : !this.canAdd}
			></KPricingHelpForm>

			{this.genDeleteDialog}
		</DefaultLayout>;
	}
};
